export default [
    {
        path: '/channel-ranges',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'1', subMenuActive:'5', title: 'headers.channel-ranges-title'},
        components: {
            default: () => import(/* webpackChunkName: "channels" */ './views/channel-range-main'),
            'section-header': () => import(/* webpackChunkName: "root" */ '../root/components/section-header')
        },
        children: [
            {
                path: '',
                name: 'channel-ranges',
                meta: {keepAlive: true, title: 'headers.channel-ranges-title', mainMenuActive:'1', subMenuActive:'5'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "channels" */ './views/channel-range-list')
                }
            }
        ]
    },
    {
        path: '/channel-families-configure',
        name: 'channel-families-configure',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'1', subMenuActive:'6', title: 'headers.channel-families-configure-title'},
        components: {
            default: () => import(/* webpackChunkName: "channels" */ './views/channel-families-configure'),
            'section-header': () => import(/* webpackChunkName: "root" */ '../root/components/section-header')
        }
    }
];
